import { ApprovalsQueuePage } from '@/components/approvals/approvals-queue-page'

export function AdminApprovals() {
  return <ApprovalsQueuePage />
}
